import InnerMenu from './inner-menu';

export default InnerMenu;
